module.exports = __webpack_public_path__ + "static/worker-57b95f77dddafc33d3fbc1bf3d23b18b.png";